<template>
  <el-select
    :value="value"
    @change="handlerChange"
    clearable
    filterable
    :disabled="readonly"
    style="width: 100%"
  >
    <el-option
      v-for="item in list"
      :key="item.code"
      :label="item.name"
      :value="item[need]"
    >
      {{ item.name }}
    </el-option>
  </el-select>
</template>

<script>
//  <DataDic v-model="xxx" type="PowerKind"></DataDic>
export default {
  //type:'PowerKind' 或 array
  //need: 'code'或'name'
  props: {
    value: {},
    type: {},
    need: {
      type: String,
      default: "code",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    type: {
      handler(n) {
        if (!n) {
          return;
        }
        if (typeof n == "string") {
          this.$get("DataDic/GetList", {
            DicType: n,
            PageSize:500,
            PageNumber:1,
          }).then((r) => {
            this.list = r.Result.map((m) => {
              return {
                code: m.DicCode,
                name: m.DicName,
              };
            });
          });
        } else {
          this.list = n;
        }
      },
      // 强制立即执行回调
      immediate: true,
    },
  },
  methods: {
    handlerChange(v) {
      this.$emit("input", v);
    },
  },
};
</script>

